import React from 'react'
import {Route, Routes} from 'react-router-dom'
import StartupShowcase from './views/StartupShowcase'
import StartupDetail from './components/StartupDetail'

export const StartupShowcaseRoutes = () => {
  return (
    <div className='mt-3'>
      <Routes>
        <Route index element={<StartupShowcase />} />
        <Route path='startup-details/:startupShowcaseId' element={<StartupDetail />} />
      </Routes>
    </div>
  )
}
